<template>
  <div
    class="base-avatar"
    :class="{'base-avatar--editable': !readonly}"
    :style="{'max-width': size + 'px'}"
    @click="onClick"
    v-on="hoverHandlers"
  >
    <img
      v-if="img"
      v-srcset
      class="avatar"
      :height="size"
      :width="size"
      :src="formattedImage"
      :alt="`${ username }'s avatar`"
    >
    <avatarBase
      v-else
      :key="size"
      :username="cleanedUsername"
      :initials="abbr"
      :size="size"
      :style="{'backgroundColor': backgroundColor}"
      :color="letterColor"
      :rounded="true"
      :custom-style="customStyle"
    />
    <base-icon
      v-if="!readonly"
      icon="pencil-circle"
      class="base-avatar__icon"
      :class="{'base-avatar__icon--hover': isHover}"
    />
  </div>
</template>

<script>
import AvatarBase from 'vue-avatar';
import styles from '@/styles/_variables.scss';
import hoverable from '../mixins/hoverable';

export default {
  name: 'BaseAvatar',
  components: {
    AvatarBase,
  },
  mixins: [hoverable],
  props: {
    backgroundColor: {
      type: String,
      default: '#E9AD7D',
    },
    img: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      required: true,
    },
    abbr: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: Number,
      default: 100,
    },
    inverse: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    sansSerif: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    formattedImage() {
      if (this.isURL(this.img)) {
        return `${this.img}?fit=crop&w=${this.size}&h=${this.size}&crop=faces${this.roundedMask}`;
      }
      return this.img;
    },
    customStyle() {
      return {
        'text-transform': 'lowercase',
        'font-family': this.sansSerif ? styles.fontFamilySansSerif : styles.fontFamilySerif,
        ...this.fontsize,
      };
    },
    fontsize() {
      // if (this.size <= 25) {
      //   if ((this.cleanedUsername?.split(' ')?.length ?? 0) < 2) {
      //     return {
      //       'font-size': '18px',
      //       'line-height': '30px',
      //     };
      //   }
      //   return null;
      // }
      if (this.size === 55) {
        return {
          'font-size': '18px',
          'line-height': '18px',
        };
      } else if (this.size === 44) {
        return {
          'font-size': '16px',
          'line-height': '16px',
        };
      } else if (this.size === 36) {
        return {
          'font-size': '14px',
          'line-height': '14px',
        };
      } else if (this.size === 24) {
        return {
          'font-size': '11px',
          'line-height': '11px',
        };
      }
      return null;
    },
    cleanedUsername() {
      const usernameParts = this.username?.trim().split(' ') ?? [''];
      if (usernameParts.length <= 1) {
        const name = usernameParts.length ? usernameParts[0] : '';
        return name.length ? name[0] : '';
      }
      return usernameParts.map((n, index) => (index <= 1 ? n[0] : '')).join(' ').trim();
    },
    letterColor() {
      return this.inverse ? '#FFFFFF' : '#333333';
    },
    roundedMask() {
      return '&mask=ellipse';
    },
  },
  methods: {
    onClick() {
      if (!this.readonly) {
        this.$emit('click');
      }
    },
    isURL(url) {
      const regex = /^(ftp|http|https):\/\/[^ "]+$/;
      return regex.test(url);
    },

  },
};
</script>

<style lang="scss" scoped>
.base-avatar {
  position: relative;
  &__icon {
    position: absolute;
    right: 0.3rem;
    bottom: 0.3rem;
    background-color: white;
    border-radius: 1rem;
    width: 1rem;
    height: 1rem;
    opacity: 0;
    transition: 0.2s all;
    &--hover {
      opacity: 1;
    }
  }
  &--editable {
    cursor: pointer;
  }
}
.avatar{
  border-radius: 100%;
  object-fit: cover;
}

</style>
